// PepperCap · "Aggiungi" nelle schede dei suggerimenti del carrello (01/11/2026).
// Aggiunge al carrello senza lasciare la pagina e fa aggiornare carrello e barra della spedizione.
import { CartAddEvent } from '@theme/events';

if (!window.__pcSugg) {
  window.__pcSugg = true;
  const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  document.addEventListener('click', async (e) => {
    const btn = e.target.closest('[data-pc-add]');
    if (!btn) return;
    e.preventDefault();
    if (btn.disabled) return;
    const label = btn.textContent;
    btn.disabled = true;
    btn.textContent = '…';
    try {
      const r = await fetch(root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(btn.dataset.pcAdd), quantity: 1 }] }),
      });
      if (!r.ok) throw new Error('add');
      const c = await (await fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })).json();
      document.dispatchEvent(
        new CartAddEvent({}, 'pc-suggerimenti', {
          source: 'pc-suggerimenti',
          itemCount: c.item_count,
          variantId: String(btn.dataset.pcAdd),
        })
      );
      // Se il pulsante resta in pagina (landing, non carrello), torna utilizzabile
      btn.textContent = btn.dataset.pcOk || label;
      setTimeout(() => {
        btn.disabled = false;
        btn.textContent = label;
      }, 2000);
    } catch (err) {
      btn.disabled = false;
      btn.textContent = btn.dataset.pcErr || label;
      setTimeout(() => (btn.textContent = label), 2500);
    }
  });
}

// Barra della spedizione gratuita: quando il carrello si aggiorna e la barra viene ridisegnata,
// riparte dal valore di prima (non da zero), così si riempie o si svuota in modo continuo.
if (!window.__pcFsSync) {
  window.__pcFsSync = true;
  const seen = new WeakSet();
  let last = null;
  const sync = () => {
    let current = null;
    document.querySelectorAll('.pc-fs').forEach((fs) => {
      const target = fs.style.getPropertyValue('--pc-fs-p');
      current = target;
      if (seen.has(fs)) return;
      seen.add(fs);
      if (last === null) return;
      fs.classList.add('pc-fs--seen');
      if (last !== target) {
        fs.classList.add('pc-fs--jump');
        fs.style.setProperty('--pc-fs-p', last);
        void fs.offsetWidth;
        requestAnimationFrame(() => {
          fs.classList.remove('pc-fs--jump');
          fs.style.setProperty('--pc-fs-p', target);
        });
      }
    });
    if (current !== null) last = current;
  };
  new MutationObserver(sync).observe(document.documentElement, { childList: true, subtree: true });
  sync();
}
